<template>
    <a-upload
        name="file"
        :accept="accept"
        :multiple="isMultiple"
        list-type="picture"
        :action="uploadAction"
        :headers="headers"
        :showUploadList="showUploadList"
        :data="{ biz: bizPath, tenantId: tenantId }"
        :fileList="fileList"
        :beforeUpload="beforeUpload"
        :remove="onRemoveFile"
        @change="handleChange">
        <a-button><a-icon type="upload" />上传</a-button>
    </a-upload>
</template>

<script>
import { DataEntryMixin } from "./mixins";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import store from "@/store";

import { getFileAccessHttpUrl } from "@/utils/index";

export default {
    name: "SdFile",
    mixins: [DataEntryMixin],
    components: {},
    props: {
        formType: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            uploadLoading: false,
            uploadAction: `${window._CONFIG["domianURL"]}${this.formType === "crm" ? "/crop/sideBar/openApi/uploadCrmFile" : "/crop/sideBar/openApi/uploadSchoolFile"}`,
            headers: {},
            fileList: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                if (val instanceof Array) {
                    this.initFileList(val.join(","));
                } else {
                    this.initFileList(val);
                }
            },
            // 立刻执行handler
            immediate: true,
        },
    },
    computed: {
        // 是否可编辑
        isModify({ $props }) {
            return Boolean($props.field.isModify);
        },
        // 可上传文件类型
        accept() {
            if (this.parameters.hasFileType.length) {
                return this.parameters.hasFileType.join(",");
            } else {
                // return '.*,audio/*,video/*,image/*';
                return "";
            }
        },
        // 文件上传路径
        bizPath() {
            // if (this.formType === "crm") {
            //     return "weComBarFile";
            // } else {
            return "field/file";
            // }
        },
        tenantId() {
            return store.getters.tenantId;
        },
        // 是否展示上传列表
        showUploadList() {
            return {
                showPreviewIcon: true,
                showRemoveIcon: true,
            };
        },
        // 是否可多选
        isMultiple() {
            return this.parameters.multiple || false;
        },
    },
    created() {
        const token = this.$ls.get(ACCESS_TOKEN);
        // const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NDgyNTM0MzQsInVzZXJuYW1lIjoiemotYWRtaW4tamxfMTM3In0.xAGpJ8UMI4-2GoTSxDQJxnHzzZIEG4c3A02-OC-tURI";
        // const token2 = store.getters.token;

        console.log(token);
        // "X-Access-Token": token,
        this.headers = { "X-Access-Token": token };
        console.log("95,上传地址", this.uploadAction, 222, this.headers);
    },
    methods: {
        // 初始化文件列表
        initFileList(paths) {
            // console.log('paths ======>', paths);
            if (!paths || paths.length === 0) {
                this.fileList = [];
                return false;
            }
            let fileList = [];
            let arr = paths.split(",");
            for (let a = 0; a < arr.length; a++) {
                if (arr[a]) {
                    let url = getFileAccessHttpUrl(arr[a], "", this.formType);
                    fileList.push({
                        uid: `-${parseInt(Math.random() * 10000, 10)}`,
                        name: this.getFileName(arr[a]),
                        status: "done",
                        url,
                        response: {
                            status: "history",
                            message: arr[a],
                        },
                    });
                }
            }
            this.fileList = fileList;
        },
        // 上传文件之前钩子
        beforeUpload(file) {
            console.log("文件的类型 =====》", file.type);
            const maxSize = this.parameters.maxSize ? this.parameters.maxSize * 1024 * 1024 : 20 * 1024 * 1024;
            if (this.parameters.hasFileType && this.parameters.hasFileType.length) {
                // 判断类型
                if (this.accept.indexOf(file.type) === -1) {
                    let str = [];
                    for (let i = 0; i < this.parameters.hasFileType.length; i++) {
                        if (i === 3) {
                            str.push(".docx");
                            continue;
                        }
                        if (i === 4) {
                            str.push(".xlsx");
                            continue;
                        }
                        str.push(this.parameters.hasFileType[i]);
                    }
                    this.$message.warning(`请上传 ${str.join("、")} 格式文件`);
                    return false;
                }
            }
            if (maxSize > file.size) {
                return true;
            } else {
                this.$message.warning("文件大小超过最大可上传文件大小");
                return false;
            }
        },
        // 上传文件的状态改变
        handleChange(info) {
            // 上传中
            if (info.file.status === "uploading") {
                this.fileList = [...info.fileList];
            }
            // 上传完成
            else if (info.file.status === "done") {
                console.log("这些值是啥 =========》", this.changeValue);
                if (!this.changeValue) {
                    this.changeValue += `${info.file.response.message}`;
                } else {
                    this.changeValue += `,${info.file.response.message}`;
                }
                console.log("文件的列表 ========》", this.fileList);
                this.$emit("onValidate");
            }
            // 删除文件
            else if (info.file.status === "removed") {
                console.log("该文件已被删除 ======》", info.file, info.fileList);
                this.fileList = info.fileList;
                if (this.fileList && this.fileList.length) {
                    let uploadList = [];
                    this.fileList.forEach((item) => {
                        uploadList.push(item.response.message);
                    });
                    this.changeValue = uploadList.join(",");
                    console.log("改变的值是啥 ======》", this.changeValue);
                } else {
                    this.changeValue = "";
                    console.log("改变的值是啥 ======》", this.changeValue);
                }
            }
        },
        // 移除文件
        onRemoveFile(file) {
            console.log("删除的文件是 ======》", file);
            // this.changeValue = '';
        },
        // 获取文件名
        getFileName(path) {
            if (path.lastIndexOf("\\") >= 0) {
                let reg = new RegExp("\\\\", "g");
                path = path.replace(reg, "/");
            }
            return path.substring(path.lastIndexOf("/") + 1);
        },
    },
};
</script>

<style scoped lang="less">
:deep(.ant-form-item-children .form-item-file) {
    display: flex;
    align-items: center;
}
</style>
